import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '918790896655';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20Casa%20Loco!%20I'd%20like%20to%20make%20a%20reservation.`;

const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[9999] flex items-center justify-center w-14 h-14 rounded-full transition-transform hover:scale-110"
      style={{ backgroundColor: '#25D366', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" stroke="#25D366" strokeWidth={1} />
    </a>
  );
};

export default WhatsAppButton;
